import React, { Component } from 'react'
import {
    Container, Spinner, Row, Col
} from 'reactstrap'
import { Link } from 'react-router-dom'
import EditProduct from './edit'
import ProductObj from '../../../utils/producto'
import ProductItem from '../../../components/productItem'
// import CategoryObj from '../../../utils/categoria'
import './AdminProductos.css'
const prod = new ProductObj()

export default class AdminProducts extends Component {
    constructor(props) {
        super(props)

        this.state = {
            product: null,
            products: []
        }
        this.productoNuevo = this.productoNuevo.bind(this)
        this.productoEditar = this.productoEditar.bind(this)
        this.productoNull = this.productoNull.bind(this)
        this.productoEliminar = this.productoEliminar.bind(this)
    }


    productoNuevo() {
        const product = new ProductObj()
        //console.log(product)
        this.setState({
            product
        })
    }

    productoEditar(product) {
        this.setState({
            product
        })
    }

    productoEliminar(e) {
        const _this = this
        const id = e.target.id
        // eslint-disable-next-line no-restricted-globals
        let eliminar = confirm(`¿Desea eliminar éste producto? \n ${e.target.name}`)

        if (eliminar) {
            prod.eliminar(id).then(() => {
                let productos = _this.state.products.filter(ele => ele.id !== id)
                _this.setState({
                    products: productos
                })
            })
        }

    }

    productoNull() {
        this.setState({
            product: null
        })
    }

    allProducts() {
        const _this = this
        prod.leerProductosAdmin().then(products => {
            _this.setState({
                products
            })
        }).catch(_this.setState({ products: [] }))
    }

    componentWillMount() {
        this.allProducts()
    }

    render() {
        window.scrollTo(0, 0)
        return (
            <Container className="AdminProductos">
                {
                    this.state.product ?
                        <EditProduct
                            producto={this.state.product}
                            atras={this.productoNull}
                        />
                        :
                        <div>
                            <h2>Administracion de productos</h2>
                            <Link className="btn btn-rojo" to={`/admin/productos/nuevo/`}>Nuevo producto</Link>
                            {
                                this.state.products.length === 0 ?
                                    <div className="spinnerProductos"><Spinner type="grow" /></div>
                                    :
                                    <Row>
                                        {
                                            this.state.products.map(p => <Col key={p.id} md={6}><ProductItem key={p.id} product={p} productoEditar={this.productoEditar} productoEliminar={this.productoEliminar} /></Col>)
                                        }
                                    </Row>
                            }
                        </div>
                }
            </Container>

        )
    }

}